import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { ProductContent } from "../_models/product-content";
import { CountryService } from "../_services/country.service";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { CourierService } from "../_services/courier.service";
import { Courier } from "../_models/courier";
import { Country } from "../_models/country";

@Component({
  selector: "app-add-courier-page",
  templateUrl: "./add-courier-page.component.html",
  styleUrls: ["./add-courier-page.component.scss"],
})
export class AddCourierPageComponent implements OnInit {
  public isModified = false;
  public newProductContent = new ProductContent();
  public courier: Courier;
  public showAddContents = true;
  public countries: Country[];
  public selectedCountry: number = 0;
  public courierTypes = [
    {
      id: "DELIVERY",
      name: "Delivery",
    },
    { id: "PICKUP", name: "Pickup" },
  ];

  constructor(
    private location: Location,
    public snackBar: MatSnackBar,
    public courierService: CourierService,
    public countryService: CountryService,
    private router: Router
  ) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.countryService.getCountries().subscribe(
      (countries) => {
        this.countries = countries;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve countries");
      }
    );
    this.courier = new Courier();
    this.courier.countryId = 0;
    this.courier.courierType = "";
  }

  isCourierValid() {
    return this.courier.name && this.courier.code;
  }

  public save(): void {
    if (!this.isCourierValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.courierService.addCourier(this.courier).subscribe(
      (courier) => {
        this.showSuccessMessage("Country was added successfully!");
        this.router.navigate(["regional", "courier"]);
      },
      (err) => {
        console.error(err);
        if (err.status == 400) {
          this.showErrorMessage("Invalid values");
        } else {
          this.showErrorMessage(
            "Sorry, your request cannot be process at the moment!"
          );
        }
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, "Success", {
      duration: 2000,
    });
  }
}
